import { createSlice } from '@reduxjs/toolkit';
import type { DeviceInfo as CapacitorDeviceInfo } from '@capacitor/device';
import type { PayloadAction } from '@reduxjs/toolkit';

export type ProseInfo = {
  version: string;
};

export type BrowserInfo = {
  language: string;
  userAgent: string;
};

export type DeviceInfo = CapacitorDeviceInfo & {
  id: string;
};

type SystemInfoState = {
  browser: BrowserInfo;
  device?: DeviceInfo;
  isReady: boolean;
  prose?: ProseInfo;
  windowId?: string;
};

const initialState: SystemInfoState = {
  isReady: false,
  browser: {
    language: navigator.language,
    userAgent: navigator.userAgent,
  },
};

const systemInfoSlice = createSlice({
  name: 'systemInfo',
  initialState,
  reducers: {
    allInfoCollected: state => {
      state.isReady = true;
    },
    deviceInfoLoaded: (state, action: PayloadAction<DeviceInfo>) => {
      state.device = action.payload;
    },
    proseInfoLoaded: (state, action: PayloadAction<ProseInfo>) => {
      state.prose = action.payload;
    },
    windowIdGenerated: (state, action: PayloadAction<string>) => {
      state.windowId = action.payload;
    },
  },
});

export const {
  allInfoCollected,
  deviceInfoLoaded,
  proseInfoLoaded,
  windowIdGenerated,
} = systemInfoSlice.actions;

export const systemInfoReducer = systemInfoSlice.reducer;
